var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66675C7.79167 1.66675 5.67057 2.54526 4.10938 4.1075C2.54658 5.67037 1.66842 7.7899 1.66797 10.0001C1.66797 12.2093 2.54687 14.3304 4.10938 15.8927C5.67057 17.4549 7.79167 18.3334 10.0013 18.3334C12.2109 18.3334 14.332 17.4549 15.8932 15.8927C17.4557 14.3304 18.3346 12.2093 18.3346 10.0001C18.3346 7.79084 17.4557 5.66974 15.8932 4.1075C14.332 2.54526 12.2109 1.66675 10.0013 1.66675Z",
    fill: "url(#paint0_linear_186_10879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44038 9.91211C7.87007 8.85378 9.48986 8.15603 10.2998 7.81888C12.6149 6.85625 13.0953 6.68906 13.4091 6.6834C13.4781 6.68229 13.6318 6.69935 13.732 6.7804C13.8154 6.84876 13.8388 6.94121 13.8505 7.00612C13.861 7.07096 13.8753 7.21875 13.8636 7.33412C13.7386 8.65182 13.1956 11.8495 12.9195 13.3254C12.8037 13.9499 12.5732 14.1592 12.3505 14.1797C11.8662 14.2242 11.499 13.8599 11.0302 13.5527C10.2972 13.0719 9.88309 12.7727 9.17085 12.3035C8.34793 11.7613 8.88179 11.4633 9.35054 10.9763C9.47293 10.8488 11.6057 8.90938 11.6461 8.73346C11.6513 8.71146 11.6565 8.62943 11.607 8.5862C11.5589 8.54284 11.4873 8.55768 11.4352 8.5694C11.361 8.58607 10.1904 9.36055 7.91955 10.8927C7.58752 11.1211 7.28673 11.2324 7.0159 11.2266C6.71903 11.2202 6.14611 11.0583 5.72033 10.9201C5.1995 10.7504 4.78413 10.6607 4.82059 10.3725C4.83882 10.2225 5.04585 10.069 5.44038 9.91211Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_10879",
    x1: 835.001,
    y1: 1.66675,
    x2: 835.001,
    y2: 1668.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram24Px);
export default __webpack_public_path__ + "static/media/Telegram_24px.5b2ebc862248a97d4b04940223e2c63f.svg";
export { ForwardRef as ReactComponent };